// directives/mml2chtml.js
import { renderMathML, initMathJax } from '@/utils/mathjax';

export default {
  inserted(el) {
    initMathJax(); // 初始化 MathJax（只会执行一次）
    renderMathML(el);
  },
  componentUpdated(el) {
    renderMathML(el);
  }
};